import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    toCard: {
        id: 'modal.topUp.general.select.to_card',
        defaultMessage: 'To card',
    },
    getNew: {
        id: 'modal.topUp.general.select.get_new',
        defaultMessage: 'Get new card',
    },
})
